export type ResultLineParticipant = {
  match_event_id: string;
  league_configuration_position_id: string | null;
  player_id: string;
};

function lineKey(row: ResultLineParticipant): string | null {
  if (!row.league_configuration_position_id) return null;
  return `${row.match_event_id}:${row.league_configuration_position_id}`;
}

function groupParticipants(rows: ResultLineParticipant[]): Map<string, string[]> {
  const grouped = new Map<string, string[]>();
  rows.forEach((row) => {
    const key = lineKey(row);
    if (!key) return;
    const players = grouped.get(key) || [];
    if (!players.includes(row.player_id)) players.push(row.player_id);
    grouped.set(key, players);
  });
  return grouped;
}

export function resultParticipantsByLine(
  activeLineupEntries: ResultLineParticipant[],
  playedEvents: ResultLineParticipant[],
): Map<string, string[]> {
  const lineupParticipants = groupParticipants(activeLineupEntries);
  const playedParticipants = groupParticipants(playedEvents);
  const result = new Map<string, string[]>();

  new Set([...lineupParticipants.keys(), ...playedParticipants.keys()]).forEach((key) => {
    const finalLineup = lineupParticipants.get(key) || [];
    result.set(key, finalLineup.length > 0 ? finalLineup : playedParticipants.get(key) || []);
  });

  return result;
}
